import React, { useMemo } from 'react';
import PropTypes from 'prop-types';
import { createFragmentContainer, graphql } from 'react-relay';

import CartItem from './CartItem';
import { SinglePhotoMsg } from '../../messages';

import { THUMBNAIL } from '../../../utils/variables';
import { getPhotoVariant } from '../../../utils/common';

function CartLineItemSinglePhoto(props) {
  const { lineItem, ...other } = props;

  const thumbnailUrl = useMemo(() => {
    const variant = getPhotoVariant(lineItem.productParams.foto.variants, THUMBNAIL);
    return variant.url;
  }, [lineItem.productParams.foto.variants]);

  return (
    <CartItem
      eventName={lineItem.product.event.name}
      icon={
        <div className="cart-item-icon-container">
          <img src={thumbnailUrl} />
        </div>
      }
      isDownloadOnly={true}
      lineItem={lineItem}
      subtitle={lineItem.productParams.foto.sgId}
      title={<SinglePhotoMsg />}
      {...other}
    />
  );
}

CartLineItemSinglePhoto.propTypes = {
  lineItem: PropTypes.object,
};

export default createFragmentContainer(CartLineItemSinglePhoto, {
  lineItem: graphql`
    fragment CartLineItemSinglePhoto_lineItem on LineItem {
      product {
        event {
          name
        }
      }
      productParams {
        ... on SingleFotoParams {
          foto {
            sgId
            variants {
              name
              url
            }
          }
        }
      }
    }
  `,
});
